// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__lur5G","clinicsSelect":"styles_clinicsSelect__16Q44"};